const getMaleOption = chronicleType => (
  { label: chronicleType === 'child-journals' ? 'Boy' : 'Male', value: 'male' }
);

const getFemaleOption = chronicleType => (
  { label: chronicleType === 'child-journals' ? 'Girl' : 'Female', value: 'female' }
);

const getNaOption = chronicleType => (
  { label: chronicleType === 'child-journals' ? 'Prefer not to say' : 'N/A', value: 'prefer_not_to_say' });

const getNonBinaryOptionƒ = chronicleType => (
  { label: chronicleType === 'child-journals' ? 'Non Binary' : 'N/A', value: 'non_binary' });

const getDontKnowOption = chronicleType => (chronicleType === 'child-journals' ? ({ label: 'Don\'t know yet', value: 'other' }) : null);

export const getGenderOptions = (chronicleType, isFromTft) => {

  if (isFromTft)
    return [
      getMaleOption(chronicleType),
      getFemaleOption(chronicleType),
    ].filter(el => !!el)

  return [
    getMaleOption(chronicleType),
    getFemaleOption(chronicleType),
    // getNonBinaryOptionƒ(chronicleType),
    getDontKnowOption(chronicleType),
  ].filter(el => !!el)
};

export const chroniclePronouns = () => [
  { label: 'She/her', value: 'she/her' },
  { label: 'He/him', value: 'he/him' },
  { label: 'They/them', value: 'they/them' },

].filter(el => !!el);

export const relationshipOptions = [
  { label: 'Mom', value: 'Mom' },
  { label: 'Dad', value: 'Dad' },
  { label: 'Grandmother', value: 'Grandmother' },
  { label: 'Grandfather', value: 'Grandfather' },
  { label: 'Other', value: 'Other' },
];